import NavBar from "./NavBar";
import Profile from "./Profile";

export default NavBar;
export { NavBar, Profile };
